exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".smartforms-block-panel .components-base-control{\r\n    width:100%;\r\n}\r\n\r\n.smartforms-block-panel select{\r\n    margin:0;\r\n}", ""]);

